<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
    <!-- <router-link to="/">{{ c.title5 }}</router-link> -->
    <!-- <router-link to="/login">{{ c.title1 }}</router-link> -->
    <!-- <router-link to="/register">{{ c.title2 }}</router-link>
    <router-link to="/forget">{{ c.title3 }}</router-link>
    <router-link to="/change">{{ c.title4 }}</router-link> -->
  </div>
</template>

<script>
import c from "./assets/message/zh-CN";
export default {
  name: "App",
  data() {
    return {
      // isMobile:''
    };
  },
  created(){
  }
};
</script>

<style>
* {
    margin: 0;
    padding: 0;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color:#df0011;/*进行修改选中项背景和字体*/
    color:#fff;
}
.el-pagination.is-background .el-pager li:hover{
    color: #fff !important;/*hover时候的文字颜色*/
}
</style>
<style lang='scss'>
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
* {
    margin: 0;
    padding: 0;
    font-family: "SiyuanBlackbody";
    // font-family: 'Helvetica Neue',Helvetica,'PingFang SC','Hiragino Sans GB',sans-serif;
}
@media only screen and (min-width: 280px) and (max-width: 320px) {
  .el-dialog{
    width:270px !important;
  }
  .el-message-box{
    width: 240px !important;
  }
  .el-message {
      min-width: 240px !important;
  }
  .el-pagination{
    // width: 250px !important;
    margin: 0 auto;
  }
  .el-date-picker {
    width: 270px;
    left: 1px !important;
    position: absolute;
    top: 312px;
  }
  .el-time-panel{
    left: -35px !important;
  }
  .el-date-picker .el-picker-panel__content {
      width: 240px;
      display: flex;
  }
  .el-date-range-picker{
    width: 300px;
  }
  // .el-picker-panel__body-wrapper{
  //   min-width: 250px;
  // }
  .el-date-range-picker .el-picker-panel__body {
    min-width: 240px;
  }
}
@media only screen and (min-width: 320px) and (max-width: 375px) {
  .el-dialog{
    width:310px !important;
  }
  .el-date-picker {
    width: 310px;
    left: 10px !important;
    position: absolute;
    top: 312px;
  }
  .el-time-panel{
    left: -25px !important;
  }
  .el-message-box{
    width: 280px !important;
  }
  .el-message {
      min-width: 280px !important;
  }
}
@media only screen and (min-width: 375px) and (max-width: 400px) {
  .el-dialog{
    width:330px !important;
  }
  .el-date-picker {
    width: 320px;
    left: 45px !important;
    position: absolute;
    top: 312px;
  }
  .el-time-panel{
    left: -20px !important;
  }
  .el-message-box{
    width: 335px !important;
  }
  .el-message {
      min-width: 335px !important;
  }
}
@media only screen and (min-width: 400px) and (max-width: 413px) {
  .el-dialog{
    width:330px !important;
  }
  .el-date-picker {
    width: 320px;
    left: 65px !important;
    position: absolute;
    top: 312px;
  }
  .el-time-panel{
    left: -20px !important;
  }
  .el-message-box{
    width: 335px !important;
  }
  .el-message {
      min-width: 335px !important;
  }
}
@media only screen and (min-width: 413px) and (max-width: 430px) {
  .el-dialog{
    width: 330px !important;
  }
  .el-date-picker {
    width: 320px;
    left: 85px !important;
    position: absolute;
    top: 312px;
  }
  .el-time-panel{
    left: -20px !important;
  }
  .el-message-box{
    width: 373px !important;
  }
  .el-message {
      min-width: 373px !important;
  }
}
@media only screen and (min-width: 430px) and (max-width: 460px) {
  .el-dialog{
    width:410px !important;
  }
  .el-date-picker {
    width: 320px;
    left: 105px !important;
    position: absolute;
    top: 312px;
  }
  .el-time-panel{
    left: -20px !important;
  }
  .el-message-box{
    width: 390px !important;
  }
  .el-message {
      min-width: 390px !important;
  }
}
@media only screen and (min-width: 460px) and (max-width: 485px) {
  .el-dialog{
    width:420px !important;
  }
  .el-date-picker {
    width: 320px;
    left: 125px !important;
    position: absolute;
    top: 312px;
  }
  .el-time-panel{
    left: -20px !important;
  }
  .el-message-box{
    width: 390px !important;
  }
  .el-message {
    min-width: 390px !important;
  }
}
@media only screen and (min-width: 485px) and (max-width: 500px) {
  .el-dialog{
    width:460px !important;
  }
  .el-date-picker {
    width: 320px;
    left: 145px !important;
    position: absolute;
    top: 312px;
  }
  .el-time-panel{
    left: -20px !important;
  }
  .el-message-box{
    width: 460px !important;
  }
  .el-message {
      min-width: 460px !important;
  }
}
@media only screen and (min-width: 500px) and (max-width: 820px) {
  .el-dialog{
    width:460px !important;
  }
  .el-message-box{
    width: 460px !important;
  }
  .el-message {
      min-width: 460px !important;
  }
}
@media only screen and (min-width: 820px) and (max-width: 1420px) {
  .el-dialog{
    width:600px !important;
  }
  .el-message-box{
    width: 460px !important;
  }
  .el-message {
      min-width: 460px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue